/* istanbul ignore file */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ContactSupportDataService extends HttpBaseService {

    private route = environment.api + 'contactSupport/send';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    submitContactForm(contactForm: any): Observable<boolean> {
        const url = `${this.route}`;
        return this.httpPost(url, contactForm);
    }
}
